module.exports = __webpack_public_path__ + "img/RJHIMYKL.db6e4bdf.png";